import React, { useCallback } from 'react';
import { useDropzone } from 'react-dropzone';

interface IProps {
  label: string;
  comment: string;
  onDrop: (files: Array<File>) => void;
}

const Dropzone: React.FC<IProps> = ({ label, comment, onDrop }) => {
  const onDropInternal = useCallback(
    (acceptedFiles) => {
      // Do something with the files
      onDrop(acceptedFiles);
    },
    [onDrop]
  );
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop: onDropInternal,
  });

  return (
    <div
      {...getRootProps()}
      className={`${
        isDragActive ? 'border-primary-light' : 'border-gray-300'
      } mt-1 flex justify-center px-6 pt-4 pb-5 border-2 border-dashed rounded-md cursor-pointer bg-gray-50`}
    >
      <div className="space-y-1 text-center">
        <input
          {...getInputProps()}
          type="file"
          id="documents"
          name="documents"
        />
        <svg
          className="mx-auto h-11 w-11 text-gray-400"
          stroke="currentColor"
          fill="none"
          viewBox="0 0 48 48"
          aria-hidden="true"
        >
          <path
            d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
        <div>
          <div className="flex text-sm text-gray-600">
            <span className="relative cursor-pointer bg-white rounded-md font-medium text-primary hover:text-primary-light focus-within:outline-none focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-primary-light">
              {label}
            </span>
            <p className="pl-1">or drag and drop</p>
          </div>
          <p className="pt-1 text-xs text-gray-500">{comment}</p>
        </div>
      </div>
    </div>
  );
};

export default Dropzone;
